const DOCUMENT = 'EDIT_BOOKING_';

const actions = {
  LOAD: DOCUMENT + 'LOAD',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  CLEAR_STARTS_AT_AND_FINISHES_AT_VALUES: DOCUMENT + 'CLEAR_STARTS_AT_AND_FINISHES_AT_VALUES',
  CHANGE_NESTED_PROPERTY: DOCUMENT + 'CHANGE_NESTED_PROPERTY',
  CHANGE_PROPERTIES: DOCUMENT + 'CHANGE_PROPERTIES',
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  SAVE: DOCUMENT + 'SAVE',
  ADD: DOCUMENT + 'ADD',
  SAVE_SUCCESS: DOCUMENT + 'SAVE_SUCCESS',
  SAVE_ERROR: DOCUMENT + 'SAVE_ERROR',
  PREV: DOCUMENT + 'PREV',
  NEXT: DOCUMENT + 'NEXT',
  CANCEL: DOCUMENT + 'CANCEL',
  TOUCH: DOCUMENT + 'TOUCH',
  LOAD_FORM_DATA: DOCUMENT + 'LOAD_FORM_DATA',
  CREATE: DOCUMENT + 'CREATE',
  OVERTIME_WARNING: DOCUMENT + 'OVERTIME_WARNING',
  OVERTIME_WARNING_SUCCESS: DOCUMENT + 'OVERTIME_WARNING_SUCCESS',
  ADD_NEW_INCENTIVE: DOCUMENT + 'ADD_NEW_INCENTIVE',
  DELETE_INCENTIVE: DOCUMENT + 'DELETE_INCENTIVE',
  UPDATE_JOB_GROUPS_VMS_ID_REQUEST: DOCUMENT + 'UPDATE_JOB_GROUPS_VMS_ID_REQUEST',
  UPDATE_JOB_GROUPS_VMS_ID_SUCCESS: DOCUMENT + 'UPDATE_JOB_GROUPS_VMS_ID_SUCCESS',
  UPDATE_JOB_GROUPS_VMS_ID_ERROR: DOCUMENT + 'UPDATE_JOB_GROUPS_VMS_ID_ERROR',
  UPDATE_JOB_VMS_ID_REQUEST: DOCUMENT + 'UPDATE_JOB_VMS_ID_REQUEST',
  UPDATE_JOB_VMS_ID_SUCCESS: DOCUMENT + 'UPDATE_JOB_VMS_ID_SUCCESS',
  UPDATE_JOB_VMS_ID_ERROR: DOCUMENT + 'UPDATE_JOB_VMS_ID_ERROR',
  CHECK_CANCELLATION_POLICIES_REQUEST: DOCUMENT + 'CHECK_CANCELLATION_POLICIES_REQUEST',
  CHECK_CANCELLATION_POLICIES_SUCCESS: DOCUMENT + 'CHECK_CANCELLATION_POLICIES_SUCCESS',
  UPDATE_PAST_JOB_REQUEST: DOCUMENT + 'UPDATE_PAST_JOB_REQUEST',
  UPDATE_PAST_JOB_SUCCESS: DOCUMENT + 'UPDATE_PAST_JOB_SUCCESS',
  UPDATE_PAST_JOB_ERROR: DOCUMENT + 'UPDATE_PAST_JOB_ERROR',

  loadData: data => ({
    type: actions.LOAD,
    payload: data,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),

  clearStartsAtAndFinisheAtValues: () => ({
    type: actions.CLEAR_STARTS_AT_AND_FINISHES_AT_VALUES,
  }),

  save: data => ({
    type: actions.SAVE,
    payload: data,
  }),

  add: data => ({
    type: actions.ADD,
    payload: data,
  }),

  saveSuccess: data => ({
    type: actions.SAVE_SUCCESS,
    payload: data,
  }),

  saveError: data => ({
    type: actions.SAVE_ERROR,
    payload: data,
  }),

  prev: () => ({
    type: actions.PREV,
  }),

  next: () => ({
    type: actions.NEXT,
  }),

  changeNestedProperty: data => ({
    type: actions.CHANGE_NESTED_PROPERTY,
    payload: data,
  }),

  changeProperties: data => ({
    type: actions.CHANGE_PROPERTIES,
    payload: data,
  }),

  changeProperty: data => ({
    type: actions.CHANGE_PROPERTY,
    payload: data,
  }),

  cancel: () => ({
    type: actions.CANCEL,
  }),

  touch: data => ({
    type: actions.TOUCH,
    payload: data,
  }),

  loadFormData: data => ({
    type: actions.LOAD_FORM_DATA,
    payload: data,
  }),

  onCreate: () => ({
    type: actions.CREATE,
  }),

  overtimeWarning: data => ({
    type: actions.OVERTIME_WARNING,
    payload: data,
  }),

  overtimeWarningSuccess: data => ({
    type: actions.OVERTIME_WARNING_SUCCESS,
    payload: data,
  }),

  onAddNewIncentive: data => ({
    type: actions.ADD_NEW_INCENTIVE,
    payload: data,
  }),

  onDeleteIncentive: data => ({
    type: actions.DELETE_INCENTIVE,
    payload: data,
  }),

  updateJobGroupsVmsIdRequest: data => ({
    type: actions.UPDATE_JOB_GROUPS_VMS_ID_REQUEST,
    payload: data,
  }),

  updateJobGroupsVmsIdSuccess: data => ({
    type: actions.UPDATE_JOB_GROUPS_VMS_ID_SUCCESS,
    payload: data,
  }),

  updateJobGroupsVmsIdError: data => ({
    type: actions.UPDATE_JOB_GROUPS_VMS_ID_ERROR,
    payload: data,
  }),

  updateJobVmsIdRequest: data => ({
    type: actions.UPDATE_JOB_VMS_ID_REQUEST,
    payload: data,
  }),

  updateJobVmsIdSuccess: data => ({
    type: actions.UPDATE_JOB_VMS_ID_SUCCESS,
    payload: data,
  }),

  updateJobVmsIdError: data => ({
    type: actions.UPDATE_JOB_VMS_ID_ERROR,
    payload: data,
  }),

  checkCancellationPoliciesRequest: data => ({
    type: actions.CHECK_CANCELLATION_POLICIES_REQUEST,
    payload: data,
  }),

  checkCancellationPoliciesSuccess: data => ({
    type: actions.CHECK_CANCELLATION_POLICIES_SUCCESS,
    payload: data,
  }),

  updatePastJobRequest: data => ({
    type: actions.UPDATE_PAST_JOB_REQUEST,
    payload: data,
  }),

  updatePastJobSuccess: data => ({
    type: actions.UPDATE_PAST_JOB_SUCCESS,
    payload: data,
  }),

  updatePastJobError: data => ({
    type: actions.UPDATE_PAST_JOB_ERROR,
    payload: data,
  }),
};

export default actions;
